<template lang="pug">
  v-container(fluid)
    h2.text-center {{ translations.title }}

    v-row.px-2.px-sm-10.pb-10()
      v-col(cols="12" md="4" sm="6")
        BaseChipSelectField(:multiple="false", :items="providerListAll" v-model="providerFilter", :label="translations.filter.provider")
      v-col(cols="12" md="4" sm="6")
        BaseChipSelectField(:multiple="false", :items="licenseListAll" v-model="licenseFilter", :label="translations.filter.license")
      v-col(cols="12" md="4" sm="6")
        BaseChipSelectField(:multiple="false", :items="jurisdictions" v-model="jurisdictionFilter", :label="translations.filter.jurisdiction")

      v-col(cols="12").text-right
        v-btn(@click="ToCSV" color="green light-1" text)
          span Descargar CSV
          v-icon.ml-4 mdi-download
        v-data-table(
          :headers="headers"
          :items="datos"
          :items-per-page="30"
          :footer-props="{'items-per-page-options': [10, 20, 30, 40, 50], 'itemsPerPageText': $t('api.datatable.rowsperpage')}"
        ).text-left
          template(v-slot:body="{ items }")
            tbody
              tr(v-for="item,ind in items", :key="'item'+item._id")
                td
                  v-avatar
                    img(alt="Avatar", :src="item.image")
                td
                  span.fantasy__block-width--8 {{ item.name }}
                td {{ item.alias }}
                td {{ item.type }}
                td
                  span.fantasy__block-width--8 {{ item.provider.n }}
                td
                  span.fantasy__block-width--8 {{ item.key }}
                td
                  BaseConfirmDialog(v-if="hasPermission('views.games.toggleGame')" @confirm="toggleState(item._id)" v-bind="translations.confirmationDialog.status")
                    template(v-slot="{ on }")
                      v-btn(v-on="on", :color="getColor(item.disabled)", :loading="loadingToggleGame" dark rounded) {{ getStatus(item.disabled) }}
                  v-chip(v-else :color="getColor(item.disabled)" text-color="white") {{ getStatus(item.disabled) }}
                td
                  GameInfoDialog(:info="item")
                td(v-if="hasPermission('views.games.editGame')")
                  BaseDialog(type="edit", :title="translationsForm.title.edit + item.name" v-slot="{close, opened}")
                    GameEdit(:game="item" @successEdit="updateGames(opened,close)", :clearForm="opened", :translations="translationsForm", :providersList="providerListAll")

      v-speed-dial(
          v-model="fab"
          bottom
          right
          fixed
          style="bottom:50px"
          direction="top"
          :transition="dialTransition")
        template(v-slot:activator)
          v-btn(v-model="fab" dark fab)
            v-icon(v-if="fab") mdi-close
            v-icon(v-else) mdi-menu
        BaseDialog(v-if="hasPermission('views.games.createGame')" type="createsimple", :title="translationsForm.title.create" v-slot="{close, opened}")
          GameCreate(@successCreate="updateGames(opened,close)", :clearForm="opened", :translations="translationsForm", :providersList="providerListAll")
        GameMultiCreateDialog(@successCreate="getGames", :translations="translationsForm", :providersList="providerListAll")
</template>

<script>

  import GameInfoDialog from "@/components/dialogs/info/GamesInfoDialog";
  import GameMultiCreateDialog from "@/components/dialogs/create/GameMultiCreateDialog";
  import GameCreate from '@/components/forms/GameCreate';
  import GameEdit from '@/components/forms/GameEdit';
  import { jurisdictions } from "@/store/variablesGlobals";
  import { base64camera } from "@/libs/otherVariables.js";

  export default {
    name: "GamesIndex",
    components: {
      GameMultiCreateDialog,
      GameInfoDialog,
      GameCreate,
      GameEdit,
    },
    data:() =>({
      jurisdictions,
      imgDefault: base64camera,
      licenseFilter: null,
      providerFilter: null,
      jurisdictionFilter: null,
      fab: false,
      dialTransition: 'slide-y-reverse-transition'
    }),
    computed: {
      translations(){
        return this.$t("views.gamesIndex");
      },
      translationsForm() {
        return this.$t("forms.game");
      },
      headers(){
        return [
          {
            text: '',
            value: 'image',
            sortable: false
          },
          {
            text: this.translations.tableHeadText.name,
            value: 'name'
          },
          {
            text: this.translations.tableHeadText.alias,
            value: 'alias'
          },
          {
            text: this.translations.tableHeadText.type,
            value: 'type'
          },
          {
            text: this.translations.tableHeadText.provider,
            value: 'provider'
          },
          {
            text: this.translations.tableHeadText.key,
            value: 'key'
          },
          {
            text: this.translations.tableHeadText.status,
            value: 'status'
          },
          {
            text: '',
            value: 'info',
            sortable: false
          },
          {
            text: '',
            value: 'edit',
            sortable: false
          },
        ]
      },
      datos(){
        const vm = this;
        return this.gamesFiltered.map(game => {
          return {
            _id: game._id,
            name: game.n,
            alias: game.a,
            provider: game.p != null ? game.p : {n:''},
            type: game.t,
            disabled: game.d,
            cfg: game.cfg,
            key: game.k,
            image: game.img != undefined ? game.img : this.imgDefault,
            license: game.l.length > 0 ? game.l[0] : null,
            jurisdictions: this.jurisdictions.filter((item)=>{
              return game.j.includes(item.value)
            }),
            launchdate: game.ld != undefined ? vm.$moment(game.ld).format('DD/MM/YYYY') : null,
            platform: {
              mobile: game.pl != undefined && game.pl.m != undefined ? game.pl.m : false,
              desktop: game.pl != undefined && game.pl.d != undefined ? game.pl.d : false,
            },
            teoricRTP: game.rtp != undefined ? game.rtp : null,
            freespins: game.fs != undefined ? game.fs : null,
            mode: {
              fun: game.fun != undefined ? game.fun : false,
            },
            volatility: game.volatility ? game.volatility : 1,
            jackpot: game.jackpot ? game.jackpot : false,
            bet: {
              default: game.bet && game.bet.default ? game.bet.default : null,
              min: game.bet && game.bet.min ? game.bet.min : null,
              max: game.bet && game.bet.max ? game.bet.max : null,
              highest: game.bet && game.bet.highest ? game.bet.highest : null,
              mwm: game.bet && game.bet.mwm ? game.bet.mwm : null,
            },
          }
        })
      },
      gamesFiltered(){
        const vm = this;
        const filters = {
          provider: {
            function: vm.filterProvider,
            condition: vm.providerFilter != null ? vm.providerFilter.value : '',
          },
          type: {
            function: vm.filterJurisdictions,
            condition: vm.jurisdictionFilter
          },
          license: {
            function: vm.filterLicense,
            condition: vm.licenseFilter
          },
        };

        return vm.gamesListAll.filter(player => {
          const filterKeys = Object.keys(filters);
          return filterKeys.every(key => {
            return filters[key]['function'](player, filters[key]['condition']);
          });
        });
      },
      providerListAll(){
        return this.$store.state.providers.map(provider => ({
          text: provider.n,
          value: provider._id
        })).sort((a, b) => a.text.localeCompare(b.text));
      },
      licenseListAll(){
        let licenses = {};
        this.gamesListAll.forEach(game => {
          game.l.forEach(license=>{
            licenses[license] = license;
          })
        })
        return Object.keys(licenses).map(item=>({
          text: item,
          value: item
        }));
      },
      gamesListAll() {
        return this.$store.state.games;
      },
      loadingToggleGame(){
        return this.$store.state.statusCode.toggleGame.loading;
      },
      statusToggleState(){
        return this.$store.state.statusCode.toggleGame.state || '';
      },
      gamesExport(){
        return this.datos.map(game => {
          return {
            Provider: game.provider.n,
            Nombre: game.name,
            LaunchID: game.key,
            Type: game.type,
            LaunchDate: game.launchdate,
            RTPTeorico: game.teoricRTP,
            Desktop: game.platform.desktop,
            Mobile: game.platform.mobile
          }
        })
      }
    },
    watch: {
      statusToggleState: function(val){
        if (val == 200){
          this.getGames();
        }
      },
    },
    created(){
      this.$store.dispatch('getGames');
      this.$store.dispatch('getProviders');
    },
    methods:{
      getColor(type){
        return type != undefined && type == true ? 'red' : 'green' ;
      },
      getStatus(type){
        return type != undefined && type == true ? this.translations.status.disabled : this.translations.status.enabled;
      },
      filterProvider(item, condition){
        return condition == undefined || condition == '' || item.p._id == condition;
      },
      filterJurisdictions(item, condition){
        return condition == undefined || condition == '' || item.j.indexOf(condition.value) != -1;
      },
      filterLicense(item, condition){
        return condition == undefined || condition == '' || item.l.join('').indexOf(condition.value) != -1;
      },
      getGames(){
        this.$store.dispatch('getGames');
      },
      updateGames(opened, closedialog){
        if(opened) {
          if(closedialog != undefined){
            closedialog();
          }
          this.$store.dispatch('getGames');
        }
      },
      toggleState(gameid){
        this.$store.dispatch('toggleGame', gameid);
      },
      ToCSV(){
        let csvContent = "data:text/csv;charset=utf-8,";
        csvContent += [
          Object.keys(this.gamesExport[0]).join(";"),
          ...this.gamesExport.map(item => Object.values(item).join(";"))
        ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");

        const data = encodeURI(csvContent);
        const link = document.createElement("a");
        const date = new Date();
        const todayDate = `${date.getFullYear()}-${date.getMonth()}-${date.getDay()}`;
        link.setAttribute("href", data);
        link.setAttribute("download", `Games ${todayDate}.csv`);
        link.click();
      }
    }
  }
</script>

<style lang="sass">
</style>